/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Step_1Inputs */

const en_svc_agents_step_1 = /** @type {(inputs: Svc_Agents_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map the task, the tools it touches and the cases that need a person.`)
};

const lv_svc_agents_step_1 = /** @type {(inputs: Svc_Agents_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izprotam uzdevumu, rīkus, ko tas skar, un gadījumus, kam vajag cilvēku.`)
};

/**
* | output |
* | --- |
* | "Map the task, the tools it touches and the cases that need a person." |
*
* @param {Svc_Agents_Step_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_step_1 = /** @type {((inputs?: Svc_Agents_Step_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Step_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_step_1(inputs)
	return en_svc_agents_step_1(inputs)
});